import React, { Component } from 'react'
import { h } from '@app/helpers/translationHelper'

class Rewards extends Component {
  render() {
    return (
      <section className="section rewards-section" id="rewards">
        <h1 className="f--purple mb-2 plate-heading plate-heading--left">
          { I18n.t('landing.awards') }
        </h1>
        <div className="grid grid--md-2--kv grid--xl-2--kv">
          <ul className="bullet-list">
            <li>
              <div className="f--l f--text"
                 dangerouslySetInnerHTML={ h('landing.awards_text_1_html') }
              />
            </li>
            <li>
              <div className="f--l f--text"
                 dangerouslySetInnerHTML={ h('landing.awards_text_2_html') }
              />
            </li>
            { window.COUNTRY === 'RU' && (
                <li>
                  <div className="f--l f--white"
                    dangerouslySetInnerHTML={ h('landing.awards_text_4_html') }
                  />
                </li>
              )
            }
          </ul>
          <div className="rewards-section__img" />
        </div>
      </section>
    )
  }
}

export default Rewards
